import { render } from "./EditConfiguration.vue?vue&type=template&id=1940ad73"
const script = {}

import "./EditConfiguration.vue?vue&type=style&index=0&id=1940ad73&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__